import { Component, Input, OnInit } from '@angular/core';
import { PriceyardService } from '../services/priceyard.service';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-price-breakdown',
  templateUrl: './price-breakdown.component.html',
  styleUrls: ['./price-breakdown.component.scss']
})
export class PriceBreakdownComponent implements OnInit {
 @Input() selectedRow;
 @Input() isFlexedCol = false;
 feeDetail: any;
  isSidePanel: boolean;
  constructor(private priceyardService: PriceyardService,
    private snackBar: MatSnackBar) { 
      this.isSidePanel = localStorage.getItem("toolPanel") === "true";
     }

  ngOnInit(): void {
    this.getFeeDtails();
  }

  getFeeDtails(){
    const payload: any = {
      fulfilmentType: this.selectedRow?.fulfillmentType || this.selectedRow?.FulfillmentType,
      accountSkuId: this.selectedRow?.accountSkuId || this.selectedRow?.AccountSkuId
    }
    this.priceyardService.GetCostFeesDetails(payload)
    .subscribe((response: any) => {
      this.feeDetail = response;
      this.feeDetail.cost = response?.cogs + response?.prepCost;
      this.feeDetail.fee = response?.fbaFees + response?.referalFees;
      this.feeDetail.breakevenTotal = this.feeDetail?.cost + this.feeDetail.fee + this.feeDetail.profitForBreakEvenPrice +this.feeDetail.markupForBreakEvenPrice;
      this.feeDetail.minPriceTotal = this.feeDetail.cost + this.feeDetail.fee + this.feeDetail.profitForMinPrice + this.feeDetail.markupForMinPrice;
      this.feeDetail.maxPriceTotal = this.feeDetail.cost + this.feeDetail.fee + this.feeDetail.profitForMaxPrice + this.feeDetail.markupForMaxPrice;
    },(error)=>{
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
    });
  }
}